<form [formGroup]="formGroup" (submit)="submit()">
    <div class="modal-header">
        <h5 class="modal-title">{{ 'reporting_CHANGE_LEGISLATION' | translate }}</h5>
        <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="activeModal.dismiss('Cancel')"></button>
    </div>

    <div class="modal-body" formArrayName="legislations">
        @for (
            legislation of formGroup.controls.legislations.controls;
            track legislation;
            let i = $index
        ) {
            <ng-container [formGroupName]="i">
                <app-checkbox-group
                    [label]="'reporting_LEGISLATION_' + legislation.value.legislationId | translate"
                    formControlName="active" />
            </ng-container>
        }
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="activeModal.dismiss('Cancel')">
            {{ 'reporting_CANCEL' | translate }}
        </button>
        <button type="submit" class="btn btn-primary">
            {{ 'reporting_SAVE' | translate }}
        </button>
    </div>
</form>
